import { Injectable } from '@angular/core';
import { Observable, ReplaySubject, tap } from 'rxjs';
import { Holiday } from '../models/holiday.model';
import moment from 'moment';
import { HolidaysService } from '../providers/api/holidays.service';

@Injectable({ providedIn: 'root' })
export class HolidayService {

  public holidays: Holiday[] = [];
  public holidaysObject: { [id: string]: Holiday } = {};

  public holidays$: ReplaySubject<Holiday[]> = new ReplaySubject<Holiday[]>(0);
  public holidaysObject$: ReplaySubject<{ [id: string]: Holiday }> = new ReplaySubject<{ [id: string]: Holiday }>(0);

  constructor(
    private holidaysApi$: HolidaysService
  ) {
  }

  getAll(): Observable<Holiday[]> {
    return this.holidaysApi$.holidaysControllerFindAll()
      .pipe(
        tap((holidays) => {
          const obHolidays = {};
          holidays.forEach(fe => {
            const dateFormat = moment(fe.date).format('DD/MM/YYYY');
            obHolidays[dateFormat] = fe;
          });
          this.holidays = holidays;
          this.holidaysObject = obHolidays;

          this.holidaysObject$.next(obHolidays);
          this.holidays$.next(holidays);
        })
      );
  }
}
